// User roles names
enum RoleNames {
  SUPER_ADMIN = 'Super Admin',
  WORKSPACE_ADMIN = 'Administrator',
  HR = 'HR',
  USER = 'Employee',
}

export { RoleNames };
